export default __webpack_public_path__ + "static/media/Marble_Rocks_Bhedaghat_2.3d5873a4.jpg";